/** @format */

export const TEST_ID = 'same-accessories-notice';
